import { inject, Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot
} from "@angular/router";
import { TabService } from "src/app/services/tab.service";
import { getUrlWithoutQueryParams } from "src/app/support/url";

@Injectable()
export class RestoreTabsGuard implements CanActivate {
  private readonly tabService = inject(TabService);

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    this.tabService.restoreTabs({
      openingTabUrl: getUrlWithoutQueryParams(state.url)
    });

    return true;
  }
}
